import QrCode from "../support/QrCode"

export default () => ({
    open: false,
    allowed: false,
    loaded: false,
    closeOnSuccess: true,
    error: null,
    QrCode: {},

    init() {
        window.addEventListener('open::qr-code::scan', ({detail: options}) => {
            this.open = true;
            this.loaded = false;
            this.allowed = false;

            this.error = null;

            this.closeOnSuccess = _.get(options, 'closeOnSuccess', true);

            this.$nextTick(() => {
                this.QrCode = QrCode(this.$refs.container.id);

                this.QrCode.init(
                    () => {
                        this.scan();

                        this.allowed = true;
                        this.loaded = true;
                    },
                    () => {
                        this.loaded = true;
                    }
                );
            });
        });

        window.addEventListener('close::qr-code::scan', () => {
            if(this.open) {
                this.stop();
            }
        });

        window.addEventListener('error::qr-code::scan', ({detail: error}) => {
            this.error = error;
        });
    },

    scan() {
        this.QrCode.scan((content) => {
            this.$dispatch('qr-code::scan', [content]);

            if(this.closeOnSuccess) {
                this.stop();
            }
        }, (error) => {
            this.$dispatch('qr-code::scan::error', error);
        });
    },

    stop() {
        this.open = false;
        this.QrCode.stop();
    }
})
